import { FiChevronLeft, FiChevronRight } from "react-icons/fi";

const PageBtn = ({ page, current, onClick }) => (
  <button
    onClick={() => onClick(page)}
    className={`min-w-8 h-8 px-2 rounded border text-sm font-medium cursor-pointer transition
      ${
        page === current
          ? "bg-primary-500 border-primary-500 text-white"
          : "border-[#E3E3E3] text-gray-600 hover:bg-gray-50"
      }`}
  >
    {page}
  </button>
);

const Pagination = ({ currentPage, lastPage, onPageChange }) => {
  if (!lastPage || lastPage <= 1) return null;

  const start = Math.max(1, currentPage - 2);
  const end = Math.min(lastPage, currentPage + 2);
  const pages = [];
  for (let i = start; i <= end; i++) pages.push(i);

  return (
    <div className="flex items-center justify-end gap-1 mt-4">
      <button
        disabled={currentPage === 1}
        onClick={() => onPageChange(currentPage - 1)}
        className="p-1.5 rounded border border-[#E3E3E3] text-gray-500 hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer"
      >
        <FiChevronLeft className="w-4 h-4" />
      </button>

      {start > 1 && (
        <>
          <PageBtn page={1} current={currentPage} onClick={onPageChange} />
          {start > 2 && <span className="px-1 text-gray-400 text-sm">…</span>}
        </>
      )}

      {pages.map((p) => (
        <PageBtn key={p} page={p} current={currentPage} onClick={onPageChange} />
      ))}

      {end < lastPage && (
        <>
          {end < lastPage - 1 && (
            <span className="px-1 text-gray-400 text-sm">…</span>
          )}
          <PageBtn page={lastPage} current={currentPage} onClick={onPageChange} />
        </>
      )}

      <button
        disabled={currentPage === lastPage}
        onClick={() => onPageChange(currentPage + 1)}
        className="p-1.5 rounded border border-[#E3E3E3] text-gray-500 hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer"
      >
        <FiChevronRight className="w-4 h-4" />
      </button>
    </div>
  );
};

export default Pagination;
